import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import App from './App.vue'
import router from '../src/router'
import store from "./store";
import VModal from 'vue-js-modal'
import VueSimpleAlert from "vue-simple-alert";
Vue.use(VModal);
Vue.use(VueSimpleAlert);

//import LoadScript from 'vue-plugin-load-script';

window.documentTypes = {
  BankOrder: { text: 'Banka Talimatı' },
  Contract: { text: 'Sözleşme' },
  General: {text: 'Genel'}
};

window.jobStatus = {
  Circulating: { text: 'Dolaşımda', css: 'primary' },
  Declined: { text: 'Reddedildi', css:'danger' },
  Finalizing: { text: 'Sonlandırılıyor', css:'info' },
  Completed: {text: 'Tamamlandı', css:'success' },
  Canceled: {text:'İptal edildi', css:'secondary'}
};

window.targetSystemKinds = {
  Ftp: { text: 'FTP' },
  Sftp: { text: 'sFTP' },
  Email: { text: 'E-posta' },
  Rem: { text: 'KEP' },
}

window.ozneKinds = {
  KurumKurulus: { text: 'Kurum/Kuruluş' },
  GercekSahis: { text: 'Gerçek Şahıs' },
  TuzelSahis: { text: 'Tüzel Şahıs' },
}

window.emptyObjectId = '000000000000000000000000';

window.getModelStateString = function(modelState){
  var msg = '', i, k;
  for(i in modelState){
      for(k = 0; k < modelState[i].length; k++) {
          msg += modelState[i][k] + '\r\n';
      }
  }
  return msg;
}

window.processErrorResponse = function(x, component){
  if(!x.response) {
    alert('Beklemediğimiz bir hata ile karşılaştık: ' + x);
    return;
  }

  switch(x.response.status) {
    case 404:
        alert('Kayıt bulunamadı. ');
        break;
    case 401:
        var msg = ''
        for(var i in x.response.data.ModelState){
            for(var k in x.response.data.ModelState[i]) {
               msg += x.response.data.ModelState[i][k] + '\r\n';
            }
          }

        alert('Bu işlem için yetkiniz yok.\r\n' + msg);
        console.log(x.response);
        break;
    case 400:
      msg = window.getModelStateString(x.response.data.ModelState);
      alert(msg);
      break;
    default:
      alert('İşlem tamamlanamadı. Lütfen tekrar deneyin.');
      console.log('Kaydetme başarısız:', x);
      component.errorMessage = "İşlem gerçekleştirilemedi: " + x;
      break;
  }
  component.loading = false;
  return x;
}


axios.defaults.baseURL = window.settings.apiUrl; //process.env.VUE_APP_API_URL;
//axios.defaults.baseURL = 'http://api.izonay.com/api';

Vue.use(VueAxios, axios)
//Vue.use(LoadScript);

Vue.config.productionTip = false;

//Vue.loadScript('/js/ObjectId.js');

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// usage: {{ file.size | prettyBytes }}
Vue.filter('prettyBytes', function (num) {
  // jacked from: https://github.com/sindresorhus/pretty-bytes
  if (typeof num !== 'number' || isNaN(num)) {
    return num;
  }

  var exponent;
  var unit;
  var neg = num < 0;
  var units = ['B', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

  if (neg) {
    num = -num;
  }

  if (num < 1) {
    return (neg ? '-' : '') + num + ' B';
  }

  exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
  num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
  unit = units[exponent];

  return (neg ? '-' : '') + num + ' ' + unit;
});

Vue.filter('money', function(num){
  if(isNaN(num))
    return num;

  return Number(parseInt(num, 10)).toLocaleString();
})

Vue.filter('date', function(date){
  if(!date)
    return null;

  if(typeof date == 'string' && !isNaN(date))
    date = new Date(parseInt(date, 10));

  if(!(date instanceof Date))
    date = new Date(date);


  
  return date.toLocaleDateString();
});


Vue.filter('datetime', function(date){
  if(!date)
    return null;

  if(typeof date == 'string' && !isNaN(date))
    date = new Date(parseInt(date, 10));

  if(!(date instanceof Date))
    date = new Date(date);


  return date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
});

// window.getJobStateLabel = function(key) {
//   var status = {
//     Circulating: 'Dolaşımda',
//     Declined: 'Reddedildi',
//     Finalizing: 'Sonlandırılıyor',
//     Completed: 'Tamamlandı',
//     Canceled: 'İptal edildi'
//   };

//   return status[key]
//   // switch(key) {
//   //   case 'Circulating'
//   //     reutrn 'Dol'
//   // };
// }

